const NAVIGATION = {
    SELECT: {
        event: 'navigation',
        eventProperties: {
            description: 'User click on app navigation',
            selection: '',
        },
    },
    HELP_CENTER: {
        event: 'Navigation - Help Center',
        eventProperties: {
            description: 'User click on help center',
            selection: '',
        },
    },
    SELECTIONS: {
        NAV_LOGO: 'navlogo',
    },
    NAV_MENU_OPENED: {
        event: 'nav_menu_opened',
        eventProperties: {
            description:
                'Triggered when a user opens/expands a navigation dropdown menu (e.g., HR Compliance, Company Policies)',
        },
    },
    AVATAR_MENU_OPENED: {
        event: 'avatar_menu_opened',
        eventProperties: {
            description:
                'Triggered when a user opens the avatar/profile dropdown menu via hover or click',
        },
    },
};

export default NAVIGATION;
